import { useState } from 'react';

const useDeleteConfirmation = ({ items, onDelete }) => {
  const [pendingIndex, setPendingIndex] = useState(null);

  const request = (index) => setPendingIndex(index);
  const cancel = () => setPendingIndex(null);
  const confirm = () => {
    if (pendingIndex === null) return;
    onDelete(pendingIndex);
    setPendingIndex(null);
  };

  const pendingItem = pendingIndex !== null ? items?.[pendingIndex] : null;

  return {
    request,
    confirm,
    cancel,
    pendingItem,
    isConfirming: pendingIndex !== null,
  };
};

export default useDeleteConfirmation;
